<template>
  <b-modal
    :hide-footer="true"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :title="$t('Editar Logradouro')"
    centered
    id="edit-logradouro"
    no-fade
  >
    <template v-slot:default>
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />
      <form @submit.prevent="editLogradouro" ref="editLogradouro">
        <div class="row toUpperCase">
          <form-input
            v-model="logradouro.cep_logradouro"
            grid="12"
            label="CEP"
            :required="true"
            v-mask="'#####-###'"
            placeholder="00000-000"
          />

          <form-select
            ref="select"
            grid="12"
            :label="$t('Bairro/Localidade')"
            :itens="options"
            v-model="logradouro.localidade"
            @search="searchLocalidade"
            :loading="loadingLocalidade"
            :required="true"
          />

          <form-input
            v-model="logradouro.tipo_logradouro"
            grid="12"
            label="Tipo (rua, avenida,igarapé etc.)"
            :required="true"
          />

          <form-input
            v-model="logradouro.titulo_logradouro"
            grid="12"
            label="Título (general, santa, pintor etc.)"
          />

          <form-input
            v-model="logradouro.nome_logradouro"
            grid="12"
            label="Nome do Logradouro"
            :required="true"
          />
        </div>

        <div class="float-right mt-3">
          <router-link
            class="btn btn-danger"
            to="/dashboard/enderecos/logradouros"
          >
            <i class="mdi mdi-close" />
            {{ $t("Cancelar") }}
          </router-link>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "Edit",
  mounted() {
    this.$bvModal.show("edit-logradouro");
    this.getLogradouro();
  },
  data() {
    return {
      loading: true,
      logradouro: {},
      options: [],
      loadingLocalidade: false,
    };
  },
  methods: {
    getLogradouro() {
      this.loading = true;
      axios
        .get("api/dashboard/enderecos/logradouros/" + this.$route.params.id)
        .then((response) => {
          this.logradouro = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/enderecos/logradouros");
        });
    },
    // Add role
    editLogradouro() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      // Send request
      axios
        .put(
          "api/dashboard/enderecos/logradouros/" + this.logradouro.id,
          this.logradouro
        )
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$router.push("/dashboard/enderecos/logradouros");
          this.$parent.getLogradouros();
        });
    },
    searchLocalidade(search) {
      if (search != "") {
        this.loadingLocalidade = true;
        this.$refs.select.openOptions(false);
        axios
          .get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
          .then((response) => {
            this.options = response.data;
            this.$refs.select.openOptions(false);
          })
          .finally(() => {
            this.$refs.select.closeOptions(false);
            setTimeout(() => {
              this.loadingLocalidade = false;
              this.$refs.select.openOptions(true);
            }, 3000);
          });
      }
    },
  },
};
</script>

<style>
.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}

.toUpperCase {
  text-transform: uppercase;
}
</style>
</style>
